<template>
  <div class="inforSet" ref="publishJob">
    <div
      class="loadShadowGif"
      style="position:fixed;left:0;right:0;bottom:0;top:0;z-index:999;display:flex;align-items:center;"
      v-show="isLoad"
    >
      <i class="loadgif"></i>
    </div>
    <div class="jobdetailForm">
      <div>
        <h1 class="addCompanyTitle">{{entName}}</h1>
        <h4 class="addJobTitle">{{dataDetail === "add" ? "新增职位" : "修改职位"}}</h4>
        <hr />
        <div class="card-content checkForm">
          <div class="draft-job" style="margin-top:20px;">
            <h5>公司信息</h5>
          </div>
          <div class="infor_field">
            <div class="infor_field">
              <label class="field_name">
                <span style="color:#f38480 !important;">*</span>企业对外简称：
              </label>
              <div class="shortNameContainer">
                <input
                  type="text"
                  name
                  class="jobNameInput"
                  v-model="shortName"
                  @input="checkShortName"
                  ref="shortNameInput"
                />
                <p class="textAlarm">字数 {{shorts}} / {{shortLimit}}</p>
              </div>
              <p
                style="display:block;width: 100%;box-sizing:border-box;padding-left: 150px;"
              >提示: 可输入公司缩写或品牌名，如 "智士网络" 或 "心职"</p>
            </div>
          </div>
          <div class="draft-job">
            <h5>基本信息</h5>
          </div>
          <div class="infor_field">
            <label class="field_name">
              <span style="color:#f38480 !important;">*</span>职位名称：
            </label>
            <input type="text" name class="jobNameInput" v-model="entJobName" @input="checkNumber" />

            <span
              style="display:block;width: 100%;box-sizing:border-box;padding-left: 150px;"
            >字数 {{inputJobNameLength}} / {{textLength}}</span>
          </div>
          <div class="infor_field">
            <label class="field_name">优先招聘：</label>
            <div>
              <el-radio-group v-model="entJobOtherTag" @change="selectTag">
                <el-radio-button
                  :label="type"
                  v-for="(type,index) in $store.state.PUBLISH.otherBtn"
                  :key="index"
                >{{type.name}}</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div class="infor_field">
            <label class="field_name">工作类型：</label>
            <div>
              <el-radio-group v-model="entJobWorkType">
                <el-radio-button
                  :label="type"
                  v-for="(type,index) in $store.state.PUBLISH.jobType"
                  :key="index"
                >{{type}}</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div class="infor_field">
            <label class="field_name">
              <span style="color:#f38480 !important;">*</span>职能分类：
            </label>
            <role :roleList="entJobFun" @returnRole="getRoleValue" ref="roleInput"></role>
            <div>
              <IdentifyInput
                class="identify"
                labelText="招聘人数："
                :mustFill="true"
                :width="recruitWidth"
                :inputValue="entJobNum.value"
                :valueVerify="entJobNum.identifyType"
                @returnValue="getEntJobNum"
                category="number"
              ></IdentifyInput>
            </div>
            <div class="anyRecruit" @change="selectInfinite">
              <el-checkbox v-model="infiniteNumber">若干</el-checkbox>
            </div>
          </div>

          <div class="infor_field">
            <label class="field_name">所属部门(子公司)：</label>
            <div>
              <input name="part" type="text" placeholder="输入部门或子公司" v-model="entJobPart" />
            </div>
          </div>
          <MainInformation ref="MainInformation"></MainInformation>
          <div class="infor_field">
            <!--部队要求-->
            <div v-if="entJobOtherTag.value == 'army'">
              <PublishTroop :q="this.q" ref="troop"></PublishTroop>
            </div>
            <!---->
            <Labels ref="labels"></Labels>
            <div class="infor_field">
              <label class="field_name">
                <span style="color:#f38480 !important;">*</span>工作地点：
              </label>
              <div style="display:flex;align-items:center;flex-wrap:wrap;">
                <MRegion
                  class="custom-region"
                  :fullrange="true"
                  :selected="selected"
                  @cRegion="getRegion"
                  :search="true"
                  ref="provinceSelect"
                ></MRegion>
                <span class="locateSplit">/</span>
                <IdentifyInput
                  class="identify"
                  :mustFill="true"
                  :inputValue="entJobAdd.value"
                  :valueVerify="entJobAdd.identifyType"
                  width="200px"
                  @returnValue="getEntJobAdd"
                ></IdentifyInput>
                <p ref="constrainRegion" class="constrainRegion">必须选择到市或市以下</p>
              </div>
            </div>
            <!--面试设置-->
            <!-- <InterviewSetting ref="interviewData" :interviewSelected="interviewSelected" :interviewAdd="interviewAdd" :cName="contactName" :cCode="contactPhone" :interiviewList="interviewList"></InterviewSetting> -->
            <div class="infor_field">
              <span class="manageLocality" @click="addStore">添加门店</span>
            </div>
            <!---->
            <div class="form_save publishBtn" v-if="purviews.manageJob">
              <button
                type="button"
                class="btn-search"
                @click="cancalPublish = true"
              >{{isPublish?'取消发布':'取消修改'}}</button>
              <button
                type="button"
                class="btn-search"
                @click="funUpload"
                style="color:#fff;background:#5f4b8b"
              >{{isPublish?'发布职位':'修改职位'}}</button>
            </div>
            <!--职能 (假装是插件)-->
            <el-dialog
              title="选择职能"
              :visible.sync="jobfunVisible"
              width="1000px"
              :append-to-body="true"
            >
              <JobFun @value="returnFun"></JobFun>
            </el-dialog>
            <!--发布成功后弹窗-->
            <el-dialog
              :visible.sync="publishSuccess"
              width="400px"
              style="overflow: hidden;"
              class="publishSuccess"
              :close-on-click-modal="false"
              :append-to-body="true"
            >
              <h1>发布成功!</h1>
              <div class="publishOperate">
                <a @click="proceed">继续添加新职位</a>
                <a @click="backRoute">确定</a>
              </div>
            </el-dialog>
            <!--取消发布弹窗-->
            <el-dialog
              :visible.sync="cancalPublish"
              width="400px"
              style="overflow: hidden;"
              class="publishSuccess"
              :close-on-click-modal="false"
              @close="cancalPublish = false"
              :append-to-body="true"
            >
              <h1>{{cancelText}}</h1>
              <div class="publishOperate">
                <a @click="cancalPublish=false">取消</a>
                <a @click="backRoute">确定</a>
              </div>
            </el-dialog>
            <!--编辑成功后弹窗-->
            <el-dialog
              :visible.sync="editSuccess"
              width="400px"
              style="overflow: hidden;"
              class="publishSuccess"
              :close-on-click-modal="false"
              :append-to-body="true"
              @close="backRoute"
            >
              <h1>修改成功!</h1>
              <div class="publishOperate">
                <a @click="backRoute">确定</a>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
    <!--管理门店-->
    <el-dialog
      :visible.sync="manageAddress"
      width="1200px"
      :close-on-click-modal="false"
      :append-to-body="true"
      @close="closeType = true"
    >
      <ManageAddress
        :interviewList="interviewMatch"
        :name="entJobName"
        :num="entJobNum.value !== undefined ? entJobNum.value : 1"
        :initCode="selected"
        :address="entJobAdd.value"
        :entId="entid"
        :allAddress="allAddress"
        :jobId="this.dataDetail.jobid ? this.dataDetail.jobid : ''"
        :closeType="closeType"
        @initCloseManageAddress="initCloseManageAddress"
      ></ManageAddress>
    </el-dialog>
  </div>
</template>
<script>
import xz from "../common";
import JobFun from "../plugins/JOBFUN";
//职能数据
import funData from "../store/funData";
//地址管理
import ManageAddress from "../components/manageAddress";
//面试设置管理
import InterviewSetting from "../components/publish/interviewSetting";
//输入框
import IdentifyInput from "../components/form/textInput";
//职能
import role from "../components/widgets/role-widget";
// 部队
import PublishTroop from "../components/publish/troop";
// 标签
import Labels from "../components/publish/labels";
// 主要信息
import MainInformation from "../components/publish/mainInformation";
export default {
  components: {
    JobFun,
    ManageAddress,
    InterviewSetting,
    IdentifyInput,
    Labels,
    MainInformation,
    role,
    PublishTroop,
  },
  props: {
    project: {
      type: String,
      default: "",
    },
    entid: {
      type: String,
      default: "",
    },
    dataDetail: {
      type: String,
      default: "",
    },
    entName: {
      type: String,
      default: "",
    },
    //所有的面试信息
    allInterview: [],
  },
  data() {
    return {
      q:"",
      // 优先招聘身份
      identity: "",
      //是否是若干
      infiniteNumber: false,
      recruitWidth: "150px",
      shortLimit: 5, //简称限制
      shorts: "", //已输入简称名字
      //地址管理
      manageAddress: false,
      //面试设置
      isInterview: true,
      //
      funData: funData, //职能数据
      selected: "", //初始化地址
      jobfunVisible: false, //是否显示职能
      publishSuccess: false, //发布成功后弹框
      cancalPublish: false, //是否取消发布
      editSuccess: false, //编辑成功后
      searchResult: [], //关键字结果集
      hasResult: false, //判断是否有结果
      editObj: {},
      //cancel文字
      cancelText: "",
      //是发布还是编辑
      isPublish: true,
      isLoad: false, //遮罩层
      //管理门店关闭状态
      closeType: false,
      //所有的门店集合
      addressList: [],
      /**字段**/
      entJobName: "",
      entJobAdd: {
        value: "",
        identifyType: "empty",
      },
      entJobNum: {
        value: "",
        identifyType: "number",
      },
      // 职能
      entJobFun: "",
      // 所属部门
      entJobPart: "",

      shortName: "",
      //面试组件的地点
      interviewSelected: "",
      interviewAdd: "",
      //所有的门店
      allAddress: [],
      //匹配到的面试设置
      interviewMatch: {},
      //运营公司名
      operationName: "",
      //输入的字数
      inputJobNameLength: 0,
      //限制字数长度
      textLength: 12,
      //企业默认联系人号码
      contactPhone: "",
      //企业默认联系人姓名
      contactName: "",
      //
      entJobWorkType: "全职",
      entJobOtherTag: {
        name: "",
        value: "",
      },
      // 显示佣金
      missionShow: false,
    };
  },
  created() {
    if (this.$route.name == "Edit") {
      //修改获取jobid ，请求job数据
      let jobid = this.$route.query.jobid;
      this.$store.commit("setJobid", jobid);
      this.cancelText = "是否取消编辑?";
      this.isPublish = false;
    } else {
      this.cancelText = "是否取消发布?";
      this.isPublish = true;
    }
    document.addEventListener(
      "click",
      (e) => {
        if (e.target.classList[0]) {
          let v = e.target.classList[0];
          if (this.$refs.jobFunInput) {
            if (
              this.$refs.jobFunInput.getElementsByClassName(v).length == 0 &&
              v != "jobFunInput" &&
              v != "mustFill"
            ) {
              this.hasResult = false;
            }
          }
        }
      },
      false
    );
  },
  computed: {
    //权限
    purviews() {
      return this.$store.state.purview;
    },
  },
  watch: {
    dataDetail: {
      handler: function () {
        // 佣金显示
        if (
          Cookies.get("userid-b") === "04F97C95-DF0F-4E4F-90DB-234E969EB323" ||
          Cookies.get("userid-b") === "a8034cc9-ea31-4df2-91f6-33b375253d4d"
        ) {
          this.missionShow = true;
        }
        if (this.dataDetail) {
          if (this.dataDetail === "add") {
            // 初始化职位信息
            this.$store.commit("setJobInit");
            // 获取职位信息
            const info = this.$store.getters.getJobInfo;
            this.setBaseInfo(info);
          } else {
            // dataDetail => jobid
            // 面试信息
            this.getInterviewInformation(this.dataDetail);
            //获取门店列表
            xz.getJobsStore(this.dataDetail).then((list) => {
              let storeList = [];
              if (list) {
                list.forEach((l) => {
                  if (
                    l.entAddr != this.entJobAdd.value ||
                    l.entNation != this.selected ||
                    l.entRemark != this.entJobName
                  ) {
                    storeList.push(l);
                  }
                });
                this.allAddress = storeList;
              } else {
                console.log("获取门店列表出错");
              }
            });
            this.isLoad = true;
            // 获取职位详情
            xz.getJobInformation(this.dataDetail).then((r) => {
              this.isLoad = false;
              // console.log('职位详情信息',r)
              if (r) {
                const info = r.entJobInfo;
                this.q = r.entJobInfo;
                this.$store.commit("publishData", info);
                this.setBaseInfo(info);
              }
            });
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 选择优先招聘身份
    selectTag(e) {
      this.identity = e.name;
      console.log("身份是", this.identity);
    },
    // 获取职位详情 设置其他信息
    setBaseInfo(info) {
      // 简称
      if (info.shortEntName) {
        let sName = info.shortEntName.trim();
        if (sName.length > this.shortLimit) {
          sName = sName.slice(0, this.shortLimit);
          this.shorts = this.shortLimit;
        } else {
          this.shorts = sName.length;
        }
        this.shortName = sName;
      } else {
        this.shortName = "";
        this.shorts = 0;
      }
      // 职位名称
      if (info.entJobName.length >= this.textLength) {
        this.entJobName = info.entJobName.slice(0, this.textLength); //职位名称
        this.inputJobNameLength = this.textLength;
      } else {
        this.entJobName = info.entJobName; //职位名称
        this.inputJobNameLength = info.entJobName.length;
      }
      // 工作类型
      this.entJobWorkType = info.entJobWorkType;
      // 优先招聘
      this.entJobOtherTag.value = info.entJobOtherTag;
      // console.log("优先招聘", info.entJobOtherTag, this.entJobOtherTag.value);
      // 根据获得的数据情况绑定对应的优先招聘  写法有点笨
      if (this.entJobOtherTag.value == "army") {
        this.entJobOtherTag.name = "退伍军人";
      }
      if (this.entJobOtherTag.value == "family") {
        this.entJobOtherTag.name = "军人家属";
      }
      if (this.entJobOtherTag.value == "stu") {
        this.entJobOtherTag.name = "在校生";
      }
      if (this.entJobOtherTag.value == "other") {
        this.entJobOtherTag.name = "其他";
      }
      // 职能分类
      this.entJobFun = info.entJobFun;
      // 招聘人数
      this.$set(this.entJobNum, "value", info.entJobNum); //招聘人数
      if (info.entJobNum === 0) {
        this.infiniteNumber = true;
        this.recruitWidth = "0px";
      }
      // 所属部门
      this.entJobPart = info.entJobPart;
      // 详细地址
      if (info.entJobAdd) {
        //如果有详细地址直接拿职位数据的，否则请求企业信息，拿企业的地址
        //默认面试地点 ////详细地址
        this.$set(this.entJobAdd, "value", info.entJobAdd);
        this.selected = info.entJobNation;
        this.interviewSelected = info.entJobNation;
      } else {
        //获取企业信息
        xz.getCompanyInformation(this.entid).then((res) => {
          if (res) {
            //默认面试地点 ////详细地址
            this.$set(this.entJobAdd, "value", res.entAdd);
            this.interviewAdd = res.entAdd;
            this.selected = res.entNation;
            //默认面试城市
            this.interviewSelected = res.entNation;
            //联系人姓名
            this.contactName = res.entConName;
            //联系人手机号
            this.contactPhone = res.entConTel;
          } else {
            console.log("获取企业信息出错");
          }
        });
      }
      // 面试
    },
    //选择是否是若干人员
    selectInfinite() {
      this.recruitWidth = this.infiniteNumber ? "0px" : "150px";
      this.entJobNum = {
        value: this.infiniteNumber ? 0 : 1,
        identifyType: "number",
      };
    },
    //获取选择的数据
    getRoleValue(v) {
      this.entJobFun = v;
      if (this.$refs.roleInput) {
        let roleCon = this.$refs.roleInput.$el;
        let role = roleCon.getElementsByClassName("roleInput")[0];
        if (role) {
          role.classList.remove("error_alert");
        }
      }
    },
    //监听输入字符
    checkNumber() {
      this.inputJobNameLength = this.entJobName.length;
      if (this.inputJobNameLength >= this.textLength) {
        this.entJobName = this.entJobName.slice(0, this.textLength);
        this.inputJobNameLength = this.textLength;
      }
    },
    //赋值方法
    getEntJobNum(v) {
      this.$set(this.entJobNum, "value", v);
    }, //招聘人数
    getEntJobAdd(v) {
      this.$set(this.entJobAdd, "value", v);
    }, //详细地址
    //初始化门店关闭
    initCloseManageAddress(list) {
      this.addressList = list;
      this.closeType = false;
      this.manageAddress = false;
    },
    //检查职能分类
    checkentjobfun() {
      if (this.entJobFun.trim()) {
        if (this.$refs.jobFunInput.classList.contains("error_alert")) {
          this.$refs.jobFunInput.classList.remove("error_alert");
        }
      }
    },
    getRegion(region) {
      //获取工作地点
      if (region.area) {
        this.editObj.entJobNation = region.area.code;
        this.selected = region.area.code;
      } else if (region.city) {
        this.editObj.entJobNation = region.city.code;
        this.selected = region.city.code;
      } else if (region.province) {
        this.editObj.entJobNation = region.province.code;
        this.selected = region.province.code;
      }
      if (this.editObj.entJobNation) {
        if (
          this.$refs.provinceSelect.$el
            .getElementsByClassName("trigger_select")[0]
            .classList.contains("error_alert")
        ) {
          this.$refs.provinceSelect.$el
            .getElementsByClassName("trigger_select")[0]
            .classList.remove("error_alert");
        }

        this.$refs.constrainRegion.style.cssText += "display:none";
      }
    },
    //添加门店验证
    addStore() {
      this.manageAddress = true;
    },

    //检查简称字数
    checkShortName() {
      this.$refs.shortNameInput.classList.remove("error_alert");
      if (this.shortName.length > this.shortLimit) {
        this.shortName = this.shortName.slice(0, this.shortLimit);
        this.shorts = this.shortLimit;
      } else {
        this.shorts = this.shortName.length;
      }
    },
    // 发布职位
    funUpload() {
      //发布
      let noFill = false;
      // 部队模块
      if (this.entJobOtherTag.value == "army") {
        const troop = this.$refs.troop;
        const troopValue = troop.returnVal();
        if (troopValue.status) {
          // 部队要求
          this.editObj.strArmyTitle = troopValue.strArmyTitle;
          this.editObj.strArmyAge = troopValue.strArmyAge;
          this.editObj.strArmyMajor = troopValue.majorItems;
          // 年龄要求
          this.editObj.strReqAge = "";
        } else {
          noFill = true;
        }
      }

      // 标签模块
      const labels = this.$refs.labels;
      const labelsValue = labels.returnVal();
      if (labelsValue) {
        this.editObj.entJobKnowTag = labelsValue.selectedKnowBtn;
        this.editObj.entJobSkillTag = labelsValue.selectedSkillBtn;
        this.editObj.entJobToolTag = labelsValue.selectedToolBtn;
        this.editObj.entJobOtherTag = labelsValue.selectedOtherBtn;
      }
      // 主要信息
      const mainInformation = this.$refs.MainInformation;
      const mainValue = mainInformation.returnVal();
      if (mainValue.status) {
        this.editObj.entWelfareTag = mainValue.entWelfareTag;
        this.editObj.coin = mainValue.commission;
        this.editObj.entJobEdu = mainValue.entJobEdu;
        this.editObj.entJobExplan = mainValue.entJobExplan;
        this.editObj.entJobLang = mainValue.entJobLang;
        this.editObj.entJobMaxPay = mainValue.entJobMaxPay;
        this.editObj.entJobMinPay = mainValue.entJobMinPay;
        this.editObj.entJobPayMonth = mainValue.entJobPayMonth;
        this.editObj.entJobWorkTime = mainValue.entJobWorkTime;
        this.editObj.hourpay = mainValue.perThing;
      } else {
        noFill = true;
      }

      //设置标签和福利
      if (!this.entJobName) noFill = true;
      let _this = this;
      //判断未填项
      let fill = this.$refs.publishJob.getElementsByClassName("mustFill");
      for (let i = 0; i < fill.length; i++) {
        if (fill[i].value == "") {
          noFill = true;
          fill[i].classList.add("error_alert");
        }
      }
      //如果没有填写简称
      if (!this.shortName) {
        noFill = true;
        this.$refs.shortNameInput.classList.add("error_alert");
      }
      if (!this.selected) {
        //如果没有选择地区
        this.$refs.provinceSelect.$el
          .getElementsByClassName("trigger_select")[0]
          .classList.add("error_alert");
      }

      //判断是否填写职能
      if (!this.entJobFun.trim()) {
        let roleCon = this.$refs.roleInput.$el;
        let role = roleCon.getElementsByClassName("roleInput")[0];
        if (role) {
          role.classList.add("error_alert");
        }
        noFill = true;
      }

      //门店数组
      let entJobAddrInfo = [];
      const store = _this.$store.getters;
      //code转名称
      let address = store.codeToggleObj(_this.selected);
      let addressName = store.localName(address, ","); //名称
      //完整地址
      if (_this.entJobAdd.value) addressName += "," + _this.entJobAdd.value;
      //调用腾讯地址转坐标接口
      let geocoder = new qq.maps.Geocoder();
      geocoder.getLocation(addressName);
      geocoder.setComplete(function (result) {
        let detail = result.detail;
        let coordinate = detail.location; //坐标
        if (!_this.editObj.entJobNation)
          _this.editObj.entJobNation = _this.selected;
        _this.editObj.entJobName = _this.entJobName;
        _this.editObj.entJobNum = _this.entJobNum.value;
        _this.editObj.entJobAdd = _this.entJobAdd.value;
        // 职能
        _this.editObj.entJobFun = _this.entJobFun;
        // 工作类型
        _this.editObj.entJobWorkType = _this.entJobWorkType;
        // 优先招聘
        // _this.editObj.entJobOtherTag = _this.entJobOtherTag.value.split(" ");
        _this.editObj.entJobOtherTag = _this.entJobOtherTag.value;
        // 子公司
        _this.editObj.entJobPart = _this.entJobPart;

        entJobAddrInfo.push(
          _this.apartPoints(
            //保存默认坐标点
            coordinate.lng,
            coordinate.lat,
            _this.editObj.jobid,
            1,
            _this.editObj.entJobName,
            _this.editObj.entJobNum,
            _this.selected,
            _this.editObj.entJobAdd
          )
        );
        //除了第一个的面试设置
        _this.addressList.forEach((list, index) => {
          if (index > 0) {
            entJobAddrInfo.push(
              _this.apartPoints(
                //保存其他坐标点
                list.lng,
                list.lat,
                _this.editObj.jobid,
                list.recruit ? 1 : 0,
                list.name,
                list.num,
                list.selected,
                list.addressDetail
              )
            );
          }
        });
        _this.editObj.entJobAddrInfo = entJobAddrInfo;
        //对外简称
        _this.editObj.shortEntName = _this.shortName;
        let _jobid = _this.dataDetail === "add" ? "" : _this.dataDetail;
        //面试时间数组
        // let interviewData = _this.getInterviewData(coordinate.lng, coordinate.lat);
        // console.log(interviewData);

        // if(!interviewData) noFill = true;
        if (noFill) {
          document.getElementsByClassName("newJob")[0].scrollTop = 0;
          return;
        }
        _this.isLoad = true;
        // if (interviewData) {
        //   interviewData.forEach(i => {
        //     i.jobId = _jobid;
        //   })
        // } else {
        //   return
        // }
        _this.editObj.viewinf = []; //所有面试设置;
        // 判断是不是项目职位
        _this.editObj.strstatus = _this.project ? 4 : "";
        //保存/新增职位信息
        // 这里是调用新增职位/修改职位api
        xz.manipulateJob(
          _this.entid ? _this.entid : _this.editObj.entid,
          _jobid,
          _this.editObj
        ).then((res) => {
          // console.log('result',res)
          res ? (_this.editSuccess = true) : console.log("发布/修改职位出错");
        });
      });
      geocoder.setError(function (result) {
        _this.$refs.provinceSelect.$el
          .getElementsByClassName("trigger_select")[0]
          .classList.add("error_alert");
        _this.$refs.constrainRegion.style.cssText += "display:block";
      });
    },
    //获取面试对象中的数据
    getInterviewData() {
      if (this.$refs.interviewData) {
        //验证填写表单
        let isEmpty = this.$refs.interviewData.checkDataIsEmpty();
        // console.log(isEmpty);
        if (isEmpty) {
          let inteviewData = [
            {
              strlng: 121.59884,
              strlat: 29.86833,
              userName: isEmpty.username,
              userTel: isEmpty.userTel,
              vDate:
                new Date().getFullYear() +
                "-" +
                (new Date().getMonth() + 1) +
                new Date().getDay(),
              bvTime: "00:00",
              evTime: "00:00",
              id: 1, //需要考虑重复自增
              vRepeat: 0,
              vDays: 0,
              vAddr: "",
              vOtherInf: "",
            },
          ];
          return inteviewData;
        }
      } else {
        return false;
      }
    },
    //门店对象
    apartPoints(
      entLong,
      entLat,
      entJobId,
      entStatus,
      entRemark,
      entRecruitNum,
      entNation,
      entAddr
    ) {
      return {
        entLong,
        entLat,
        entJobId,
        entStatus,
        entRemark,
        entRecruitNum,
        entNation,
        entAddr,
      };
    },
    //返回上一级
    backRoute() {
      this.reset();
      this.cancalPublish = false;
      this.$emit("closePublish");
    },
    //重置
    reset() {
      //企业默认联系人姓名和号码
      (this.contactPhone = ""), (this.contactName = "");
      this.$store.commit("setJobInit");
      this.allAddress = [];
      this.interviewMatch = {};
    },
    //返回选择的职能
    returnFun(data) {
      this.entJobFun = data;
      this.jobfunVisible = false;
    },
    //选择结果
    chooseResult(e) {
      this.entJobFun = e.target.innerText;
      this.hasResult = false;
    },

    //获取面试
    getInterviewInformation(jobid) {
      xz.getInterviewInformation(jobid).then((res) => {
        if (res) {
          //匹配面试时间
          this.interviewList = res;
          if (Array.isArray(res)) {
            //如果是数组遍历查找
            //设置面试详细地址
            this.interviewAdd = res[0].StrVaddr;

            res.forEach((s) => {
              if (s.GdJobId == this.editObj.jobid) {
                this.interviewMatch = {
                  userName: s.Username,
                  userTel: s.Usertel,
                  vDate: s.DtvDate,
                  vDays: s.IntEveryDay,
                  vOtherInf: s.StrOtherInfo,
                  vBtime: s.DtBvtime,
                  vEtime: s.DtEvtime,
                  vaddr: s.StrVaddr,
                };
              }
            });
          } else {
            //如果是对象直接赋值
            //设置面试详细地址
            this.interviewAdd = res.StrVaddr;
            this.interviewMatch = {
              userName: res.Username,
              userTel: res.Usertel,
              vDate: res.DtvDate,
              vDays: res.IntEveryDay,
              vOtherInf: res.StrOtherInfo,
              vBtime: res.DtBvtime,
              vEtime: res.DtEvtime,
              vaddr: res.StrVaddr,
            };
          }
        } else {
          console.log("获取面试信息失败");
        }
      });
    },
    //继续添加职位
    proceed() {
      this.reset();
      this.$router.go(0);
    },
  },
};
</script>
<style scoped>
.anyRecruit {
  margin-left: 10px;
}
.addCompanyTitle {
  font-size: 25px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
}

.addJobTitle {
  font-size: 18px;
  font-weight: bold;
  color: #5f4b8b;
}

.field_name {
  line-height: 45px;
}
.jobNameInput {
  width: 550px;
  border: 1px solid #ddd;
  border-radius: 6px;
  height: 45px;
  font-size: 14px;
  padding: 0 15px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: none;
}
.shortNameContainer {
  display: flex;
}
.shortNameContainer .jobNameInput {
  width: 200px !important;
}
.textAlarm {
  margin-left: 10px;
  line-height: 45px;
}
.constrainRegion {
  color: #c82a2e !important;
  font-size: 14px;
  margin-top: 5px;
  width: 100%;
  display: none;
}
</style>
<style>
.eduContainer .el-radio-button__inner {
  padding: 12px 15px !important;
}
</style> 